import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { auth, environment } from '../../environments/environment';
import { authorizationInterceptor, optionalApiInterceptor } from '@mkp/core/feature-interceptor';
import { MissingTranslationSentryHandler } from '@mkp/core/feature-translate';
import { SentryService } from '@mkp/core/util-sentry';
import { getAuthDomain, getAuthRedirectUri } from '@mkp/shared/util-auth';
import { EffectsModule } from '@ngrx/effects';
import { trackingEffects } from '@mkp/tracking/state';
import { Store } from '@ngrx/store';
import { MissingTranslationHandler, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { RootStoreModule } from '@mkp/core/state-root-store';
import { AppRoutingModule } from '../app-routing.module';
import { provideClientEnvironment } from '../providers/environment.provider';
import { provideTopHeaderStore } from '../providers/top-header.store';
import { moduleImportGuard } from './helpers';

// override connection so auth supports both 'Username-Password-Authentication' and 'email'
const auth0PasswordlessConfig = {
  ...auth,
  connection: '',
  domain: getAuthDomain(auth),
  redirectUri: getAuthRedirectUri(auth),
};
const modules = [
  BrowserAnimationsModule,
  AppRoutingModule,
  EffectsModule.forFeature([trackingEffects]),
  RootStoreModule.forRoot(environment.ngrxDevTools, environment.name !== 'dev'),
  AuthModule.forRoot(auth0PasswordlessConfig),
];

@NgModule({
  imports: [modules],
  exports: [modules],
  providers: [
    provideHttpClient(
      withInterceptors([optionalApiInterceptor, authorizationInterceptor]),
      withInterceptorsFromDi()
    ),
    provideClientEnvironment(),
    provideTopHeaderStore(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        enforceLoading: true,
      }),
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationSentryHandler,
        deps: [SentryService, Store],
      },
    }),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });
    moduleImportGuard(parentModule, 'CoreModule');
  }
}
